const hongKongFeature = {
    type: 'Feature',
    id: 'HK',
    properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.41,
        'hc-middle-y': 0.56,
        'hc-key': 'hk',
        'hc-a2': 'HK',
        name: 'Hong Kong',
        labelrank: '2',
        'country-abbrev': 'Hong Kong',
        subregion: 'Eastern Asia',
        'region-wb': 'East Asia & Pacific',
        'iso-a3': 'HKG',
        'iso-a2': 'HK',
        'woe-id': '211424993',
        continent: 'Asia',
    },
    geometry: {
        type: 'MultiPolygon',
        coordinates: [
            [
                [
                    [7791, 7478],
                    [7819, 7454],
                    [7824, 7420],
                    [7794, 7408],
                    [7836, 7385],
                    [7812, 7368],
                    [7814, 7337],
                    [7794, 7326],
                    [7749, 7262],
                    [7758, 7244],
                    [7731, 7235],
                    [7661, 7167],
                    [7610, 7163],
                    [7593, 7144],
                    [7576, 7170],
                    [7574, 7142],
                    [7489, 7118],
                ],
            ],
        ],
    },
};

const bermudaFeature = {
    type: 'Feature',
    id: 'BM',
    properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.68,
        'hc-middle-y': 0.68,
        'hc-key': 'bm',
        'hc-a2': 'BM',
        name: 'Bermuda',
        labelrank: '2',
        'country-abbrev': 'U.S.A.',
        subregion: 'Northern America',
        'region-wb': 'North America',
        'iso-a3': 'BMD',
        'iso-a2': 'BM',
        'woe-id': '211424995',
        continent: 'North America',
    },
    geometry: {
        type: 'MultiPolygon',
        coordinates: [
            [
                [
                    [2672, 7644],
                    [2552, 7435],
                    [2451, 7367],
                    [2341, 7363],
                    [2241, 7244],
                    [2161, 7170],
                ],
            ],
        ],
    },
};

const singaporeFeature = {
    type: 'Feature',
    id: 'SG',
    properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.41,
        'hc-middle-y': 0.56,
        'hc-key': 'sg',
        'hc-a2': 'SG',
        name: 'Singapore',
        labelrank: '2',
        'country-abbrev': 'Singapore',
        subregion: 'Eastern Asia',
        'region-wb': 'East Asia & Pacific',
        'iso-a3': 'SGP',
        'iso-a2': 'SG',
        'woe-id': '211424998',
        continent: 'Asia',
    },
    geometry: {
        type: 'MultiPolygon',
        coordinates: [
            [
                [
                    [7211, 6538],
                    [7319, 6454],
                    [7424, 6440],
                    [7594, 6428],
                ],
            ],
        ],
    },
};

const koreaFeature = {
    type: 'Feature',
    id: 'KR1',
    properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.41,
        'hc-middle-y': 0.56,
        'hc-key': 'kr1',
        'hc-a2': 'KR1',
        name: 'Korea',
        labelrank: '2',
        'country-abbrev': 'Korea',
        subregion: 'Eastern Asia',
        'region-wb': 'East Asia & Pacific',
        'iso-a3': 'KR1',
        'iso-a2': 'KR1',
        'woe-id': '211424898',
        continent: 'Asia',
    },
    geometry: {
        type: 'Polygon',
        coordinates: [
            [
                [8019, 7768],
                [8079, 7684],
                [8214, 7620],
                [8254, 7688],
            ],
        ],
    },
};

const chinaCords = [
    [
        [6842, 7305],
        [6840, 7326],
        [6819, 7322],
        [6773, 7330],
        [6756, 7323],
        [6729, 7336],
        [6699, 7367],
        [6683, 7364],
        [6640, 7401],
        [6608, 7397],
        [6541, 7434],
        [6530, 7473],
        [6563, 7480],
        [6542, 7507],
        [6546, 7534],
        [6527, 7544],
        [6513, 7572],
        [6500, 7571],
        [6482, 7577],
        [6459, 7605],
        [6416, 7624],
        [6411, 7627],
        [6426, 7631],
        [6423, 7675],
        [6395, 7677],
        [6389, 7707],
        [6399, 7728],
        [6446, 7748],
        [6450, 7736],
        [6482, 7759],
        [6521, 7763],
        [6529, 7774],
        [6584, 7803],
        [6602, 7838],
        [6581, 7906],
        [6646, 7924],
        [6668, 7986],
        [6719, 7972],
        [6741, 7981],
        [6750, 8032],
        [6795, 8058],
        [6801, 8059],
        [6810, 8061],
        [6814, 8039],
        [6847, 8016],
        [6885, 8003],
        [6906, 7963],
        [6901, 7912],
        [6979, 7903],
        [7034, 7879],
        [7064, 7822],
        [7220, 7815],
        [7232, 7803],
        [7282, 7788],
        [7326, 7787],
        [7372, 7807],
        [7453, 7813],
        [7526, 7857],
        [7511, 7885],
        [7528, 7908],
        [7575, 7895],
        [7603, 7919],
        [7637, 7921],
        [7664, 7953],
        [7714, 7968],
        [7756, 7963],
        [7762, 7975],
        [7722, 8015],
        [7698, 8015],
        [7696, 8015],
        [7691, 8008],
        [7642, 8005],
        [7632, 8021],
        [7667, 8086],
        [7699, 8074],
        [7742, 8093],
        [7740, 8107],
        [7768, 8158],
        [7788, 8176],
        [7766, 8201],
        [7790, 8222],
        [7862, 8234],
        [7935, 8210],
        [8005, 8075],
        [8043, 8071],
        [8086, 8027],
        [8093, 8004],
        [8135, 8005],
        [8192, 8031],
        [8204, 8005],
        [8185, 7988],
        [8178, 7951],
        [8146, 7907],
        [8138, 7916],
        [8121, 7913],
        [8090, 7899],
        [8099, 7870],
        [8091, 7827],
        [8078, 7815],
        [8057, 7831],
        [8053, 7812],
        [8004, 7796],
        [8007, 7774],
        [7962, 7785],
        [7943, 7758],
        [7895, 7730],
        [7838, 7706],
        [7799, 7682],
        [7804, 7705],
        [7833, 7744],
        [7800, 7758],
        [7778, 7733],
        [7751, 7722],
        [7736, 7698],
        [7699, 7695],
        [7708, 7662],
        [7731, 7662],
        [7749, 7627],
        [7787, 7651],
        [7812, 7637],
        [7845, 7637],
        [7787, 7604],
        [7742, 7557],
        [7773, 7532],
        [7791, 7478],
        [7466, 7084],
        [7461, 7122],
        [7422, 7134],
        [7409, 7122],
        [7366, 7149],
        [7372, 7161],
        [7329, 7180],
        [7289, 7154],
        [7245, 7162],
        [7234, 7150],
        [7217, 7146],
        [7222, 7111],
        [7206, 7124],
        [7177, 7120],
        [7170, 7139],
        [7146, 7143],
        [7157, 7171],
        [7138, 7175],
        [7130, 7203],
        [7101, 7195],
        [7103, 7234],
        [7133, 7260],
        [7132, 7313],
        [7098, 7343],
        [7092, 7333],
        [7057, 7370],
        [7032, 7360],
        [7012, 7369],
        [6953, 7324],
        [6923, 7319],
        [6882, 7338],
        [6842, 7305],
    ],
];

export { hongKongFeature, bermudaFeature, singaporeFeature, koreaFeature, chinaCords };
